import { queryOptions, useQuery } from '@tanstack/react-query';

import { getHeroById, getHeroByType, getHeroes } from '@/lib/api/hero';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 * These define the query configuration for hero-related queries
 */
export const heroQueries = {
  /**
   * Get all heroes
   */
  all: () =>
    queryOptions({
      queryKey: queryKeys.heroes.all(),
      queryFn: getHeroes,
      staleTime: 1000 * 60 * 10, // 10 minutes
      retry: false,
    }),

  /**
   * Get hero by type (piercing or tattoo)
   */
  byType: (type: 'piercing' | 'tattoo') =>
    queryOptions({
      queryKey: queryKeys.heroes.byType(type),
      queryFn: () => getHeroByType(type),
      staleTime: 1000 * 60 * 10, // 10 minutes
      enabled: !!type,
      retry: false,
    }),

  /**
   * Get hero by ID
   */
  byId: (id: string) =>
    queryOptions({
      queryKey: queryKeys.heroes.byId(id),
      queryFn: () => getHeroById(id),
      staleTime: 1000 * 60 * 10,
      enabled: !!id,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch all heroes
 */
export const useGetHeroes = () => useQuery(heroQueries.all());

/**
 * Hook to fetch hero by type
 */
export const useGetHeroByType = (type: 'piercing' | 'tattoo') => useQuery(heroQueries.byType(type));

/**
 * Hook to fetch hero by ID
 */
export const useGetHeroById = (id: string) => useQuery(heroQueries.byId(id));
